export default "__VITE_ASSET__LwEBcc7B__"